import "index.scss";
import "@fontsource-variable/source-serif-4";

// Import all javascript files from src/_components
// This only works under webpack, but we are using esbuild
// TODO: need to figure that out
if (require.context) {
    const componentsContext = require.context(
        "bridgetownComponents",
        true,
        /.js$/,
    );
    componentsContext.keys().forEach(componentsContext);
}

console.info("Bridgetown is loaded!");

document.addEventListener("DOMContentLoaded", () => {
    const hamburgerBtn = document.getElementById("hamburger-btn");
    const mobileMenu = document.getElementById("mobile-menu");
    const closeMenuBtn = document.getElementById("close-menu-btn");

    if (hamburgerBtn && mobileMenu && closeMenuBtn) {
        hamburgerBtn.addEventListener("click", () => {
            mobileMenu.classList.toggle("is-active");
        });

        closeMenuBtn.addEventListener("click", () => {
            mobileMenu.classList.remove("is-active");
        });

        // Close menu when clicking outside
        document.addEventListener("click", (event) => {
            if (
                !mobileMenu.contains(event.target) &&
                !hamburgerBtn.contains(event.target)
            ) {
                mobileMenu.classList.remove("is-active");
            }
        });
    }
});
